import { forwardRef } from 'react';

// Components
import { DefaultAvatar as Avatar } from '@/components/base/Avatar';

// Types
import type { DefaultAvatarProps } from '@/components/base/Avatar';
import type { SocialProfileNetworkType } from '@/types/socialProfileType';

type SocialProfileAvatarPropsType = Omit<DefaultAvatarProps, 'url'> & {
    profile: {
        auth_status?: {
            type?: string;
        };
        external_api_data?: {
            avatar?: string;
        };
        slug?: string;
        social_network_type?: SocialProfileNetworkType;
    };
};

const SocialProfileAvatar = forwardRef<HTMLDivElement, SocialProfileAvatarPropsType>(
    ({ profile, ...restProps }, ref) => (
        <Avatar
            ref={ref}
            fallback={profile?.slug?.[0]}
            url={profile?.external_api_data?.avatar}
            profileType={profile?.social_network_type}
            error={profile?.auth_status?.type === 'error'}
            warning={profile?.auth_status?.type === 'warning'}
            {...restProps}
        />
    )
);

SocialProfileAvatar.displayName = 'SocialProfileAvatar';

export default SocialProfileAvatar;
